


































import { Vue, Component, Prop } from "vue-property-decorator";

// Enums/Data
import {
  ContractProductsTypes,
  ContractProductsKinds
} from "@/data/enums/contractProducts";
import {
  IsActiveParam,
  IsInactiveParam
} from "@/data/filters/contractProducts";

// Types
import { IClient } from "@/models/clients";
import { Location } from "vue-router";

@Component({
  components: {
    "contract-categories-provider": () =>
      import(
        "@/components/app/global/contractCategories/contractCategoriesProvider.vue"
      )
  }
})
export default class UsedContractCategories extends Vue {
  // Props

  @Prop({ default: null })
  public clientId!: IClient["id"];

  @Prop({ default: null })
  public client!: IClient;

  @Prop({ default: null })
  public routeName!: Location["name"];

  @Prop({ default: null })
  public goBackRoute!: Location;

  @Prop({ default: ContractProductsTypes.ALL })
  public cpType!: string;

  @Prop({ default: ContractProductsKinds.ALL })
  public cpKind!: ContractProductsKinds;

  @Prop({ default: 8 })
  public limit!: number;

  @Prop({ default: false })
  public handleLoading!: boolean;

  // Variables

  public useLimit = true;

  // Computed

  public get manualFilters() {
    return {
      ...this.typeManualFilters,
      ...this.kindManualFilters
    };
  }

  public get typeManualFilters() {
    if (this.cpType === ContractProductsTypes.SUBSCRIPTIONS)
      return { "filter[billing_cycle_months|neq]": 0 };
    if (this.cpType === ContractProductsTypes.OTPS)
      return { "filter[billing_cycle_months]": 0 };
    return {};
  }

  public get kindManualFilters() {
    if (this.cpKind === ContractProductsKinds.ACTIVE) return IsActiveParam();
    if (this.cpKind === ContractProductsKinds.CANCELLED)
      return IsInactiveParam();
    return {};
  }

  public get isStaged() {
    return this.client?.staged_import ?? false;
  }

  // Methods

  public getCategories(categories) {
    if (this.useLimit) return categories.slice(0, this.limit);
    return categories;
  }

  public showMoreCategoriesButton(categories) {
    return this.useLimit && categories.length > this.limit;
  }
}
